import { render, staticRenderFns } from "./BrowseKosakuView.vue?vue&type=template&id=7bba16ec&scoped=true&"
import script from "./BrowseKosakuView.vue?vue&type=script&lang=js&"
export * from "./BrowseKosakuView.vue?vue&type=script&lang=js&"
import style0 from "./BrowseKosakuView.vue?vue&type=style&index=0&id=7bba16ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba16ec",
  null
  
)

export default component.exports